<template>
  <div>

    <div class="drugstores-products-stage">

      <div class="row">
        <SearchBar2
            :searchOptions="fieldsAvailableForSearch"
            @searchRequest="searchOnList($event)"
        />
      </div>

      <div v-if="bindModeOn === true" class="row">
        <div class="form-group">
          <label for="showOnlyUnBound" style="margin-right:4px!important">Pokaż tylko niepowiązane</label>
          <input type="checkbox" id="showOnlyUnBound" v-model="showOnlyUnBound"/>
        </div>
      </div>
      <div class="drugstores-products-table-container">
        <div>
          <CommonTable2
              :table="tableData"
              :rowIdentifier="rowIdentifierKey"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="commonModule.getRawDrugstoresProductsDataTotal"
              :totalPages="commonModule.getRawDrugstoresProductsPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              @onPageChange="currentPage = $event"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :showMassActions="true"
              :showRowActions="false"
              :multiselect="true"
          />
        </div>


      </div>


    </div>


  </div>

</template>


<script>
import CommonTable2 from "@/components/widgets/CommonTable2";

import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import {log} from "@/state/pinia/log";
import {productsHelperMethods} from "./helper/productsHelperMethods";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {mapStores} from "pinia";

export default {
  name: "BoundLocalProductsList",
  props: {
    boundWithCentralGuid: {
      type: String,
      required: true,
      default: () => null
    },
    bindModeOn: {
      type: Boolean,
      default: () => false
    }

  },
  emits: ["onSelect", "onUnbind", "onBind"],
  components: {
    SearchBar2,
    CommonTable2
  },
  data() {
    return {
      rowIdentifierKey: "data_row_id",
      tableData: {},
      currentPage: 1,
      sortingDirection: "ASC",
      sortingKey: "NAZWA_TOWARU",
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },
      localProductsRows: [],
      availableHeaders: [],
      tableMassActions: [
        {
          text: "Usuń powiązania",
          icon: "fas fa-link-slash",
          action: "remove-central-product-binding",
          class: "btn btn-warning table-actions-button edit-button",
          enabled: true,
        }
      ],
      rowActions: [],
      productsVisibleHeaders: ["bloz", "data_row_id", "id_apteki", "nazwa_towaru", "nip","producent", "nazwa_kartoteki_centralnej_towaru"],
      drugstoresLocalProductsVisibleHeadersTitlesMap: {
        "bloz": "Bloz",
        "data_row_id": "IdLocal",
        "id_apteki": "Apteka",
        "nazwa_towaru": "Nazwa towaru",
        "nip": "NIP",
        "producent": "Producent",
        "nazwa_kartoteki_centralnej_towaru": "Centralny towar"

      },
      fieldsAvailableForSearch: [],
      showOnlyUnBound: false,
      refreshTable: true, //added key to force re-rendering
      localIdsSelected: []

    };
  },
  computed: {
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    }

  },
  methods: {

    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.refreshLocalProductsData();
    },
    runAction(event) {
      log.log(event);
    },

    refreshLocalProductsData() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych o towarach lokalnych w aptekach.");
      return this.commonModule.httpGetRawDrugstoresProductsHeaders().then(() => {
        this.refreshTable = false;

        var centralGuidToFilter = this.bindModeOn === true ? null : this.boundWithCentralGuid ;
        log.log("centralGuidToFilter: " + centralGuidToFilter);

        return productsHelperMethods.refreshLocalProductsList(this.rowActions, this.drugstoresLocalProductsVisibleHeadersTitlesMap, this.productsVisibleHeaders, this.currentPage, this.sortingKey,
            this.sortingDirection, this.searchRequest, this.showOnlyUnBound, centralGuidToFilter).then((responsePayload) => {
          this.availableHeaders = responsePayload.availableHeaders;
          this.localProductHeaders = responsePayload.localProductHeaders;
          this.localProductsRows = responsePayload.localProductsRows;
          var localProductsRowsFiltered = this.localProductsRows
          if(this.bindModeOn === true){
            localProductsRowsFiltered =[];
            // hide local product already bound with current central product

            for (let i = 0; i < this.localProductsRows.length; i++) {
              if(this.localProductsRows[i]['guid_kartoteki_centralnej_towaru'] === this.boundWithCentralGuid) {
                // omit this item // TODO: add method in backend which will include bindModeOn an omit items that are already bound to current central product
              }else{
                localProductsRowsFiltered.push(this.localProductsRows[i]);
              }
            }
          }

          this.tableData = {
            headers: this.localProductHeaders,
            data: localProductsRowsFiltered,
            massActions: this.tableMassActions
          }

        }).then(() => {
          this.refreshTable = true;
          productsHelperMethods.refreshFieldsAvailableForSearch(this.availableHeaders, this.drugstoresLocalProductsVisibleHeadersTitlesMap).then((responsePayload) => {
            this.fieldsAvailableForSearch = responsePayload.fieldsAvailableForSearch;
          });
        });
      });
    },

    runMassAction(event) {
      log.log(event);
      if (event.action.action === "remove-central-product-binding") {
        this.$emit("onUnbind", event.items);
        productsHelperMethods.unBindCentralProduct(event.items, this.rowIdentifierKey, this.localProductsRows).then((responsePayload) => {
          if (responsePayload.isConfirmed) {
            this.refreshLocalProductsData();
          }
        });
      } else if (event.action.action === "bind-central-product") {
        this.$emit("onBind", this.localIdsSelected);
        productsHelperMethods.bindWithProduct(this.localIdsSelected, this.rowIdentifierKey, null, this.boundWithCentralGuid);
      }
    },

    sort(sortKey) {
      log.log(sortKey);
      this.sortingKey = sortKey;
      this.refreshLocalProductsData();
      this.toggleSortingDirection();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    checkAction(event) {
      this.localIdsSelected = event.items
      this.$emit("onSelect", event.items);
    },


  },
  watch: {
    currentPage: {
      handler() {
        this.refreshLocalProductsData();
      },
      deep: true,
    },

    showOnlyUnBound: {
      handler() {
        this.refreshLocalProductsData();
      },
      deep: true,
    },


  },
  mounted() {
    if (this.bindModeOn === true) {
      this.tableMassActions.push({
        text: "Powiąż z obecnym towarem centralnym",
        icon: "fas fa-link",
        action: "bind-central-product",
        class: "btn btn-success table-actions-button edit-button",
        enabled: true,
      });
    }
  },
  created() {
    this.refreshLocalProductsData();
  },
};
</script>

<style scoped>
.drugstores-products-stage {
  margin-left: 16px;
  margin-right: 16px;
}

.drugstores-products-table-container {
}

.drugstores-products-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.table-success {
  background-color: #d4edda;
  color: #155724;
}


.table-info {
  background-color: #d4edda;
  color: #152c57;
}

.table-warning {
  background-color: #fff3cd;
  color: #856404;
}

.table-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.product-stage-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}


</style>
